import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useGetUser } from '../../hooks/useGetUser';
import AcaoCard from '../../components/TreinamentoCard';
import styles from './styles.module.scss';
import { getTreinamentos, postBuscaTreinamento } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';


const Treinamentos = props => {

    const history = useHistory();
    const [acoes, setAcoes] = useState([])
    const [buscar, setBuscar] = useState('')
    const [pagina, setPagina] = useState(1)
    const [maxPage, setMaxPage] = useState(0)
    const [verMais, setVerMais] = useState(true)
    const [modalLoading, setModalLoading] = useState(false);
    

    const getAcoes = async(novaPagina = 1) => {
        setModalLoading(true)
        const data = await getTreinamentos(novaPagina);
        setModalLoading(false)
        setPagina(novaPagina)
        setMaxPage(data.maxPage)
        setAcoes(data.data)
    } 

    const user = useGetUser();

    useEffect(()=>{
        (maxPage > pagina ) ? setVerMais(true) : setVerMais(false); 
    },[pagina, maxPage])

    const addPage = async () => {
        setModalLoading(true)
        const data = await getTreinamentos(pagina + 1);
        setModalLoading(false)
        setPagina(pagina + 1)
        setMaxPage(data.maxPage)
        setAcoes([...acoes, ...data.data])
    }

    const findAcoes = async () => {
        try {
            const acoes = await postBuscaTreinamento(buscar)
            setAcoes(acoes.data)
        }
        catch {}
    }

    useEffect(() => {
        getAcoes()
    },[])

    return (
        <>

        {(user.perfilAcesso === 'Master') && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Treinamentos
                    </div>
                    <div className={styles.buttonWrapper}>

                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/treinamentos/adicionar')}}>
                            Novo Treinamento
                        </button>
                    </div>
                    <div className={styles.subTitle}>
                        Treinamentos Cadastrados
                    </div>
                    <div className={styles.buscar}>
                        <FormControl>
                            <TextField  type="text"  size="small"
                                onChange={(e) => {setBuscar(e.target.value)}}
                                label="Faça sua busca"
                                value={buscar}
                                variant="filled"
                                className="customFilledInput"
                                onKeyDown= {
                                    (e) => {
                                        if (e.key === 'Enter') {
                                            findAcoes();
                                            e.preventDefault();
                                        }
                                    }
                                }
                                InputProps={{endAdornment: (
                                    <button onClick={findAcoes} className={styles.searcButton}>
                                        <FontAwesomeIcon icon={faSearch}/>
                                    </button>
                                )}}
                            />
                        </FormControl>
                    </div>
                    <div className={styles.acoesWrapper}>
                        {acoes.map(
                            (acao) => {return (<AcaoCard acao={acao} key={acao.id}/>)}
                        )}
                    </div>
                    { verMais && (
                        <div className={styles.verMaisWrapper}>
                            <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                Ver mais
                            </button>
                        </div>
                    )}
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </div>
            </>
        )}
        </>

    );
  
}

export default Treinamentos;